import { initializeApp } from 'firebase/app';

function resolveAuthDomain() {
  const configured = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
  if (typeof window === 'undefined') return configured;
  const host = String(window.location.hostname || '');
  const isFirebaseHost = host.endsWith('.web.app') || host.endsWith('.firebaseapp.com');
  if (isFirebaseHost) return host;
  return configured;
}

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: resolveAuthDomain(),
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

export default app;
